import { CameraIcon } from "@heroicons/react/20/solid";
import {
  ArrowDownTrayIcon,
  LockClosedIcon,
  PaperClipIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import { useAtom, atom } from "jotai";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../customHooks/config";
import Dialog from "../../dialog/Dialog";
import { USER_DETAILS } from "../../layout/Layout";
import AutoCompleteSelect from "../../input/autoComplete/AutoCompleteSelect";
import ConfirmPasswordInput from "../../input/TextField/ConfirmPasswordInput";
import PasswordInput from "../../input/TextField/PasswordInput";
import TextInput from "../../input/TextField/TextInput";
import Spinner from "../../layout/loader/Spinner";
import { Tooltip as ReactTooltip } from "react-tooltip";
import UploadDialog from "../../section/JobSection/UploadDialog";
import profilePicture from "../../../assets/png/profilePicture.png";

export const USER_DETAILS_UPDATE = atom({});

function Setting() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [existingPassword, setExistingPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [reNewPassword, setReNewPassword] = useState(null);
  const [userDetails] = useAtom(USER_DETAILS);
  const [locationData, setLocationData] = useState([]);
  const [userInfoUpdate, setUserInfoUpdate] = useAtom(USER_DETAILS_UPDATE);
  const [passwordChecksNew, setPasswordChecksNew] = useState(false);
  const [passwordChecksRe, setPasswordChecksRe] = useState(false);
  const vendorId = userDetails?.data?.user_details?.vendor_details?.vendor_id;
  const status =  userDetails?.data?.user_details?.vendor_status;
  const fileValue =  userDetails?.data?.user_details?.file;

  const [data, setData] = useState({});

  function validateUPI(upiID) {
    const upiRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return upiRegex.test(upiID);
  }
  const [openUpload, setOpenUpload] = useState(false);
      
      const handleClickOpenUpload = () => {
       setOpenUpload(true);
      };

  useEffect(() => {
    axios
      .get(`${BASE_URL}vendor/settings/profile/?vendor_id=${vendorId}`, {
        withCredentials: true,
      })
      .then((res) => {
        // setData(res?.data?.data?.data)
        const nums = res?.data?.data?.data;
        setData({
          ...nums,
          location: {
            city: nums?.current_city,
            state: nums?.current_state,
            city_id: nums?.current_city_id,
            state_id: nums?.current_state_id,
          },
          vendor_location: {
            city: nums?.city,
            state: nums?.state,
            city_id: nums?.city_id,
            state_id: nums?.state_id,
          },
          accountDetails: {
            account_type: { type: nums?.account_type, id: 1 },
            account_no: nums?.account_no,
            account_holder_name: nums?.account_holder_name,
            bank_name: nums?.bank_name,
            ifsc_code: nums?.ifsc_code,
            upi_id: nums?.upi_id,
          },
        });
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, [vendorId]);

  const onHandleChangeExisting = (e) => {
    setExistingPassword(e.target.value);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangePassword = () => {
    if (
      newPassword === reNewPassword &&
      passwordChecksNew &&
      passwordChecksRe
    ) {
      axios
        .post(
          `${BASE_URL}vendor/settings/change_password/`,
          { current_password: existingPassword, new_password: newPassword },
          { withCredentials: true }
        )
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            handleClose();
          } else toast.error(res?.data?.data?.message);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
        });
    } else {
      if (!passwordChecksNew || !passwordChecksRe)
        toast.error("Passwords doesn't follow the given checks");
      else toast.error("Passwords doesn't match with Each other");
    }
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}api/location/city_state/`)
      .then((res) => {
        setLocationData(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  const DialogActions = (btnColor) => {
    return (
      <>
        {" "}
        <div className="grid grid-cols-1 gap-4 px-8 py-7  pt-2">
          <div>
            <button
              type="button"
              className="btn-primary font-normal"
              onClick={handleChangePassword}
            >
              Change Password
            </button>
          </div>
        </div>
      </>
    );
  };

  const handleChangeDetails_fullName = (e) => {
    setData({
      ...data,
      user_name: e.target.value,
    });
  };

  const handleChangeDetails_phone = (e) => {
    setData({
      ...data,
      phone: e.target.value,
    });
  };

  const handleChangeDetails_Alernatephone = (e) => {
    setData({
      ...data,
      alternate_phone: e.target.value,
    });
  };

  const handleChangeDetails_CurrentAdd = (e) => {
    setData({
      ...data,
      current_address: e.target.value,
    });
  };
  // const handleChangeDetails_Location =(e) =>{
  //   setData({
  //     ...data,
  //     location:{}
  //   })

  // }

  const handleChangeDetails_VendorName = (e) => {
    setData({
      ...data,
      vendor_name: e.target.value,
    });
  };

  const handleChangeDetails_website = (e) => {
    setData({
      ...data,
      website: e.target.value,
    });
  };

  const handleChangeDetails_address = (e) => {
    setData({
      ...data,
      address: e.target.value,
    });
  };

  const optionalLabel = [
    <div style={{ display: "flex", alignItems: "center" }}>
      {" "}
      Alt-Contact no{" "}
      <p style={{ color: "#6C757D", fontSize: "12px", marginLeft: "5px" }}>
        (optional)
      </p>
    </div>,
  ];

  const validationCheck = () => {
    let error = false;
    if (String(data?.phone)?.length !== 10) {
      error = true;
      toast.error("Please Enter Valid Phone Number");
    }
    // else if(data?.alternate_phone.length !== 10){
    //   error = true;
    //   toast.error("Please Enter Valid Alternate Phone Number")
    // }
    else if (validateUPI(data?.accountDetails?.upi_id)) {
      error = true;
      toast.error("Please Enter Valid UPI ID");
    }
    return error;
  };

  const handleUpdateProfile = () => {
    const form = new FormData();
    const [first_name, last_name] = data?.user_name.split(" ");
    first_name && form.append("first_name", first_name);
    last_name && form.append("last_name", last_name);
    data?.phone && form.append("phone", data?.phone);
    data?.alternate_phone &&
      form.append("alternate_phone", data?.alternate_phone);

    data?.current_address &&
      form.append("current_address", data?.current_address);

    data?.vendor_name && form.append("vendor_name", data?.vendor_name);

    data?.website && form.append("website", data?.website);

    data?.location && form.append("current_city", data?.location?.city_id);
    data?.location && form.append("current_state", data?.location?.state_id);
    data?.vendor_location &&
      form.append("city", data?.vendor_location?.city_id);
    data?.vendor_location &&
      form.append("state", data?.vendor_location?.state_id);
    data?.address && form.append("address", data?.address);
    data?.accountDetails?.account_type &&
      form.append("account_type", data?.accountDetails?.account_type?.type);
    data?.accountDetails?.account_no &&
      form.append("account_no", data?.accountDetails?.account_no);
    data?.accountDetails?.account_holder_name &&
      form.append(
        "account_holder_name",
        data?.accountDetails?.account_holder_name
      );
    data?.accountDetails?.bank_name &&
      form.append("bank_name", data?.accountDetails?.bank_name);
    data?.accountDetails?.ifsc_code &&
      form.append("ifsc_code", data?.accountDetails?.ifsc_code);
    data?.accountDetails?.upi_id &&
      form.append("upi_id", data?.accountDetails?.upi_id);
    const profile_picture = selectedImage;
    profile_picture && form.append("profile_picture", profile_picture);

    if (!validationCheck()) {
      setLoading(true);
      axios
        .patch(`${BASE_URL}vendor/settings/profile/${vendorId}/`, form, {
          withCredentials: true,
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            setUserInfoUpdate({ ...userInfoUpdate, changed: true });
          } else toast.error(res?.data?.data?.message);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoading(false);
        });
    }
  };

  const handleChangeAccountDetails = (e, key) => {
    const value = e.target.value;
    setData({
      ...data,
      accountDetails: {
        ...data?.accountDetails,
        [key]: value,
      },
    });
  };

  const handleAccept = () => {
    if(status === "PENDING" && fileValue) toast.success("Your Profile is in Pending Stage")
    else handleClickOpenUpload();
  }

  return (
    <div>
     <UploadDialog open={openUpload} setOpen={setOpenUpload} handleClickOpen={handleClickOpenUpload} />
      <div className=" w-full flex  flex-col relative pt-4 pb-8">
        <div className=" w-full flex  justify-end items-center">
          <div>
            <button
              onClick={handleClickOpen}
              className="border border-[#2563EB] rounded-md text-[#2563EB] text-sm h-[40px] px-3 font-normal flex items-center "
            >
              <LockClosedIcon className="h-5 w-5 mr-1  text-[#2563EB]" /> Change
              Password
            </button>
          </div>
        </div>
        <div className="flex flex-col items-center ">
          <div className=" relative flex flex-col items-end ">
            <div className=" bg-[#EEEFF5] border border-[#CBD5E1] rounded-full  h-[150px] w-[150px] ">
              <img
                alt="not found"
                className="w-[100%] h-[100%] object-cover rounded-full "
                src={
                  selectedImage
                    ? URL.createObjectURL(selectedImage)
                    : data?.profile_picture ? data?.profile_picture : profilePicture
                }
              />
            </div>
            <button
              onClick={(e) => {
                inputRef.current.click();
              }}
              className="bg-[#D9D9D9] absolute bottom-0 rounded-full  p-3 "
            >
              <CameraIcon className="h4 w-4 " />
            </button>
          </div>
          <input
            ref={inputRef}
            type="file"
            className="hidden"
            name="myImage"
            onChange={(event) => {
              setSelectedImage(event.target.files[0]);
            }}
          />
        </div>

        <div className="w-full mt-7">
          <h3 className="text-lg ">Vendor Information</h3>

          <div className="grid grid-cols-2 gap-4 mt-6 ">
            <div>
              <TextInput
                label="Vendor Name"
                value={data?.vendor_name}
                onChange={handleChangeDetails_VendorName}
              />
            </div>
            <div>
              <TextInput
                label="Website "
                value={data?.website}
                onChange={handleChangeDetails_website}
              />
            </div>{" "}
            <div style={{ marginTop: "-2px" }}>
              <AutoCompleteSelect
                label="Vendor Current Location"
                data={locationData}
                details={data}
                setDetails={setData}
              />
            </div>{" "}
            <div>
              <TextInput
                label="Current Address"
                value={data?.address}
                onChange={handleChangeDetails_address}
              />
            </div>{" "}
          </div>
        </div>

        <div className="w-full mt-5">
          <h3 className="text-lg ">User Informaton</h3>
          <p className="text-sm text-[#6C757D] mt-2 ">
            Change your identity information
          </p>

          <div className="grid grid-cols-2 gap-4 mt-6">
            <div>
              <TextInput
                label="Full Name"
                value={data?.user_name}
                onChange={handleChangeDetails_fullName}
              />
            </div>
            <div>
              <TextInput label="Email " value={data?.email} disabled />
            </div>{" "}
            <div>
              <TextInput
                label="Contact no"
                value={data?.phone}
                onChange={handleChangeDetails_phone}
              />
            </div>{" "}
            <div>
              <TextInput
                optional={optionalLabel}
                value={data?.alternate_phone}
                onChange={handleChangeDetails_Alernatephone}
              />
            </div>{" "}
            <div>
              <AutoCompleteSelect
                label="Current Location"
                data={locationData}
                details={data}
                setDetails={setData}
              />
            </div>{" "}
            <div>
              <TextInput
                label="Current Address"
                value={data?.current_address}
                onChange={handleChangeDetails_CurrentAdd}
              />
            </div>{" "}
          </div>

          <div className="w-full mt-5">
            <h3 className="text-lg ">Account Informaton</h3>
            <p className="text-sm text-[#6C757D] mt-2 ">
              Your bank account information{" "}
            </p>

            <div className="grid grid-cols-2 gap-4 mt-6">
              <div>
                <div>
                  {/* <AutoCompleteSelect
                    label="Account type"
                    data={accountType}
                    details={data}
                    setDetails={setData}
                  /> */}

                  <TextInput
                    label="Account type"
                    value={data?.accountDetails?.account_type?.type}
                    // onChange={(e) => handleChangeAccountDetails(e, "account_no")}
                    disabled
                  />
                </div>{" "}
              </div>
              <div>
                <TextInput
                  label="Account no "
                  value={data?.accountDetails?.account_no}
                  onChange={(e) => handleChangeAccountDetails(e, "account_no")}
                  disabled
                />
              </div>{" "}
              <div>
                <TextInput
                  label="Account’s holder name"
                  value={data?.accountDetails?.account_holder_name}
                  onChange={(e) =>
                    handleChangeAccountDetails(e, "account_holder_name")
                  }
                  disabled
                />
              </div>{" "}
              <div>
                <TextInput
                  label="Bank name"
                  optional={optionalLabel}
                  value={data?.accountDetails?.bank_name}
                  onChange={(e) => handleChangeAccountDetails(e, "bank_name")}
                  disabled
                />
              </div>{" "}
              <div>
                <TextInput
                  label="IFSC code"
                  value={data?.accountDetails?.ifsc_code}
                  onChange={(e) => handleChangeAccountDetails(e, "ifsc_code")}
                  disabled
                />
              </div>{" "}
              <div>
                <TextInput
                  label="UPI id (optional)"
                  value={data?.accountDetails?.upi_id}
                  onChange={(e) => handleChangeAccountDetails(e, "upi_id")}
                  disabled
                />
              </div>{" "}
            </div>
          </div>

          <hr className="h-px my-4 bg-[#CBD5E1] border-0 " />

          <h3 className="text-lg mt-8">Submitted Document</h3>
          <p className="text-sm text-[#6C757D] mt-2 ">
            View your submitted document
          </p>

          <div className="grid grid-cols-2 gap-4 mt-5 ">
            <div>
              <div className=" bg-white border border-1 mt-3 border-[#CBD5E1] p-4 rounded-lg flex justify-between  items-center ">
                <div>
                  <p className="text-xs font-bold  text-[#2563EB] flex   ">
                    <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />
                    Document signed by {data?.user_name}
                  </p>
                </div>

                <div>
                  {userDetails?.data?.user_details?.vendor_status ===
                  "ACCEPTED" ? (
                    <button
                      className="bg-[#2563EB] rounded-full h-[40px] w-[40px] flex justify-center items-center "
                      onClick={() => {
                        window.open(data?.vendor_agreement);
                      }}
                    >
                      <ArrowDownTrayIcon className="h-4 w-4 text-white " />
                    </button>
                  ) : (userDetails?.data?.user_details?.vendor_status ===
                    "PENDING") ? (userDetails?.data?.user_details?.file) ? (
                    <button
                      className="bg-[#F0AD4E] text-[white] w-full px-2 py-1 rounded-[5px] flex justify-center items-center "
                      onClick={handleAccept}
                    >
                      Approval Pending
                    </button>
                  ) :(<button
                    className="bg-[#2563EB] text-[white] w-full px-2 py-1 rounded-[5px] flex justify-center items-center "
                    onClick={handleAccept}
                  >
                    Upload Agreement
                  </button>) :( <button
                      className="bg-[#EF4444] text-[white] w-full px-2 py-1 rounded-[5px] flex justify-center items-center "
                      onClick={() => {
                        window.open(data?.vendor_agreement);
                      }}
                    >
                      Rejected{" "}
                      {data?.reject_reason?.length > 0 && (
                        <InformationCircleIcon
                          data-tooltip-id={data?.reject_reason}
                          className="h-4 ml-1 w-4 text-white "
                        />
                      )}
                    </button>
                  )}
                  <ReactTooltip
                    id={data?.reject_reason}
                    place="right"
                    content={data?.reject_reason}
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center ">
              {" "}
              {/* <p className="text-sm text-[#6C757D] pt-3">
                (You signed this agreement to join GetWork)
              </p> */}
            </div>{" "}
          </div>
        </div>

        <div className="flex  justify-end mt-8 ">
          <button
            className="btn-primary px-3 w-[200px]  font-normal flex  justify-center items-center "
            onClick={handleUpdateProfile}
          >
            {loading ? <Spinner /> : "Update Profile"}
          </button>
        </div>
      </div>
      <div>
        <Dialog
          visible={open}
          title={"Change Password"}
          handleCloseDialog={handleClose}
          actionsPannel={DialogActions("bg-green")}
          size={"w-2/7"}
          color={"bg-green"}
        >
          <div className="h-[260px] w-[350px]">
            <div>
              <PasswordInput
                label="Existing password"
                onChange={onHandleChangeExisting}
              />
            </div>
            <div>
              <ConfirmPasswordInput
                label="Create new password"
                setPassword={setNewPassword}
                setPasswordChecks={setPasswordChecksNew}
              />
            </div>
            <div>
              <ConfirmPasswordInput
                label="Re-type new password"
                setPassword={setReNewPassword}
                setPasswordChecks={setPasswordChecksRe}
              />
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default Setting;

const accountType = [
  { id: 1, type: "Savings Account" },
  { id: 2, type: "Current Account " },
];
